import React, { useEffect, useState } from "react";
import { MainLayout } from "components/Layout";
import { Head } from "components/Head";
import { axios } from "lib/axios";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import { UPLOADS_URL } from "config";

export const Search = () => {
  const location = useLocation();
  const searchQuery = new URLSearchParams(location.search).get("q");
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await axios.post("/search", { q: searchQuery });
        setSearchResults(response);
      } catch (error) {
        setError("An error occurred while searching.");
      } finally {
        setIsLoading(false);
      }
    };

    if (searchQuery) {
      fetchData();
    }
  }, [searchQuery]);

  return (
    <MainLayout title="Search">
      <Head title="Search" description="Search results" />
      <div className="mx-4 md:mx-32 my-2 mt-8">
        <h1 className="text-xl font-bold">Search Results</h1>
        <span>Indexing results from News, circulars, summary sheets, and other documents</span>
      </div>

      <div className="mx-4 md:mx-28 my-2">
        <div className="w-full">
          <div className="p-4">
            {isLoading && <div className="text-center my-4">Loading...</div>}
            {error && <div className="text-red-500 my-4">Error: {error}</div>}
            {searchResults.posts?.length > 0 && (
              <div className="space-y-4 border border-gray-200 p-4 rounded-md">
                <h2 className="text-md font-bold">News Posts</h2>
                <ul>
                  {searchResults.posts.map((result) => (
                    <li key={result.slug}>
                      <Link
                        to={`/news/${result.slug}`}
                        className="text-gray-800 hover:text-blue-500 hover:underline"
                      >
                        {result.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {searchResults.circulars?.length > 0 && (
              <div className="space-y-4 mt-6  border border-gray-200 p-4 rounded-md">
                <h2 className="text-md font-bold">Circulars</h2>
                <ul>
                  {searchResults.circulars.map((result) => (
                    <li key={result._id} className="pt-2">
                      <a
                        target="_blank"
                        href={UPLOADS_URL + result.location}
                        className="text-gray-800 hover:text-blue-500 hover:underline"
                      >
                        {result.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {searchResults.summarySheets?.length > 0 && (
              <div className="space-y-4 mt-6  border border-gray-200 p-4 rounded-md">
                <h2 className="text-md font-bold">Summary Sheets</h2>
                <ul>
                  {searchResults.summarySheets.map((result) => (
                    <li key={result._id} className="pt-2">
                      <a
                        target="_blank"
                        href={UPLOADS_URL + result.location}
                        className="text-gray-800 hover:text-blue-500 hover:underline"
                      >
                        {result.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {searchResults.otherDocuments?.length > 0 && (
              <div className="space-y-4 mt-6 border border-gray-200 p-4 rounded-md">
                <h2 className="text-md font-bold">Other Documents</h2>
                <ul>
                  {searchResults.otherDocuments.map((result) => (
                    <li key={result._id} className="pt-2">
                      <a
                        target="_blank"
                        href={UPLOADS_URL + result.location}
                        className="text-gray-800 hover:text-blue-500 hover:underline"
                      >
                        {result.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

